module.exports = __webpack_public_path__ + "static/media/LIGHT GREEN EVENTS.fa021f16.svg";